import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore } from 'redux-persist'
import thunkMiddleware from 'redux-thunk'
import reduxReset from 'redux-reset'
import { createLogger } from 'redux-logger'

import rootReducer from './reducers/rootReducer'

const loggerMiddleware = createLogger()
const check_app_environment = process.env.REACT_APP_ENVIRONMENT
let enHanceCreateStore
let persistor

if (check_app_environment === 'dev' || check_app_environment === 'local') {
	enHanceCreateStore = compose(
		applyMiddleware(thunkMiddleware, loggerMiddleware),
		reduxReset({ type: 'RESET' }) // Will use 'RESET' as default action.type to trigger reset
	)(createStore)
} else {
	enHanceCreateStore = compose(
		applyMiddleware(thunkMiddleware),
		reduxReset({ type: 'RESET' }) // Will use 'RESET' as default action.type to trigger reset
	)(createStore)
}

const store = enHanceCreateStore(rootReducer)

persistor = persistStore(store)

export { store, persistor }
